import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type FeatureCategoryClasses =
  | 'sectionTitle'
  | 'expandedSectionTitle'
  | 'accordionDetails'
  | 'accordionSummary'
  | 'expandIcon'
  | 'expandedIcon';

const featureCategoryStyles = makeStyles<ISpcTheme, FeatureCategoryClasses>(
  ({ palette }) => ({
    sectionTitle: {
      fontWeight: 'bold',
      textTransform: 'uppercase',
    },
    expandedSectionTitle: {
      color: palette.text.primary,
    },
    accordionSummary: {
      color: palette.text.primary,
      padding: '0 15px',
    },
    accordionDetails: {
      padding: '0 5px',
    },
    expandIcon: {
      color: palette.text.primary,
      padding: '5px',
    },
    expandedIcon: {
      color: palette.text.primary,
    },
  }),
  { name: 'Customise_Feature_Category' },
);

export default featureCategoryStyles;
